import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { InboundFaxMemberDto } from '@app/core/model';
import { NotificationService } from '@app/core/service';
import { MfeCoreModule } from '@mynexus/mfe-core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ifa-assign-member-modal',
  templateUrl: './assign-member-modal.component.html',
  styleUrls: ['./assign-member-modal.component.scss'],
  imports: [MfeCoreModule, ButtonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AssignMemberModalComponent implements OnInit {
  public readonly ref: DynamicDialogRef = inject(DynamicDialogRef);
  public readonly refConfig: DynamicDialogConfig = inject(DynamicDialogConfig);
  public readonly notificationService: NotificationService = inject(NotificationService);
  tenantId = this.refConfig.data.tenantId;
  tenantName = this.refConfig.data.tenantName;
  lineOfBusinessId = this.refConfig.data.lineOfBusinessId;

  selectedMember: InboundFaxMemberDto;

  ngOnInit(): void {
    this.refConfig.closable = true;
  }

  public handleRowClicked(event: CustomEvent): void {
    const member = JSON.parse(event.detail);
    if (!member) {
      this.selectedMember = null;
    } else {
      const memberDto: InboundFaxMemberDto = {
        memberId: member.memberId,
        tenantId: member.tenantId,
        lineOfBusinessId: member.lineOfBusinessId,
        benefitPlanId: member.benefitPlanID,
        benefitPlan: member.benefitPlanName,
        subscriberNumber: member.subscriberNumber,
        fullName: `${member.firstName} ${member.middleName ? member.middleName + ' ' : ''}${member.lastName}`,
        lastName: member.lastName,
        firstName: member.firstName,
        middleName: member.middleName,
        dateOfBirth: member.dateOfBirth,
        displayMemberId: member.displayMemberId,
      };
      this.selectedMember = memberDto;
    }
  }

  public submitClick(): void {
    this.ref.close(this);
  }

  public cancelClick(): void {
    this.ref.close();
  }
}
